import { useCallback, useMemo, useState } from "react";

export const useVisibility = () => {
	const [visible, setVisible] = useState(false);

	const show = useCallback(() => {
		setVisible(true);
	}, []);

	const hide = useCallback(() => {
		setVisible(false);
	}, []);

	return {
		visible,
		show,
		hide,
	};
};
